<div>
  <public-header></public-header>
  <div class="layout-container">
  <div class="container-fluid container-xs">
    <router-outlet></router-outlet>
  </div> 
</div>   
</div>
<app-footer></app-footer> 
